import styled, { css, keyframes } from 'styled-components'

import { Reset, TransitionPrimary } from '@/lib/mixins'

const caretBlink = keyframes`
  0%, 49% { opacity: 1; }
  50%, 100% { opacity: 0; }
`

export const TaxInputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  width: 100%;
`

export const TaxInputLabel = styled.span`
  font-size: 1.1rem;
  font-weight: 600;
`

export const TaxInputControlWrapper = styled.div`
  position: relative;
`

export const TaxInputControl = styled.div<{ $hasError?: boolean }>`
  display: flex;
  height: 4rem;
  border: 1px solid ${({ theme }) => theme.color.line};
  background: ${({ theme }) => theme.color.body};
  ${TransitionPrimary('border-color')}

  &:focus-within {
    border-color: currentColor;
  }

  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: var(--color-red);
    `};
`

export const TaxCountryButton = styled.button`
  ${Reset('button')}
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border-right: 1px solid ${({ theme }) => theme.color.line};
  font-size: 1.5rem;
  font-weight: 600;
  flex: 0 0 6rem;

  > span:nth-child(2) {
    font-size: 1rem;
  }
`

export const TaxInputFieldWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  min-width: 0;
`

export const TaxInputCaret = styled.span<{ $left: number }>`
  position: absolute;
  top: 50%;
  left: ${({ $left }) => `${$left}px`};
  transform: translateY(-50%);
  width: 2px;
  height: 1.4em;
  background: currentColor;
  pointer-events: none;
  animation: ${caretBlink} 1s steps(1, end) infinite;
`

export const TaxInputField = styled.input`
  ${Reset('all')}
  appearance: none;
  flex: 1;
  min-width: 0;
  padding: 0 1.15rem;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.color.global};
  background: transparent;

  &::placeholder {
    color: ${({ theme }) => theme.color.muted};
  }

  &:focus {
    box-shadow: none;
    outline: 0;
  }
`

export const TaxCountryDropdown = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 5;
  width: 6rem;
  max-height: 18rem;
  overflow: auto;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.1);
  background: ${({ theme }) => theme.color.body};

  ${props =>
    props.theme.contrastMode &&
    css`
      border: 1px solid ${props => props.theme.color.global};
    `};
`

export const TaxCountryOption = styled.button<{ $active?: boolean }>`
  ${Reset('button')}
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 0 0.85rem;
  font-size: 1.5rem;
  text-align: left;

  span:nth-child(2) {
    font-size: 1rem;
  }

  ${({ $active }) =>
    $active &&
    css`
      background: ${({ theme }) => theme.color.primaryLight};
    `};
`

export const TaxInputError = styled.span`
  min-height: 1rem;
  color: ${props => props.theme.color.red};
  font-size: 0.85rem;
  line-height: 1.2;
`
